import React, {Component} from 'react';
import axios from 'axios';
import Select from 'react-select';
import {Button} from 'react-bootstrap';
import ContractItem from "./ContractItem";
import ConditionalBlock from "./ConditionalBlock";

export default class ContractItems extends Component {
    constructor() {
        super();

        this.state = {
            units: [],
            items: [],
            next_key: 0,
            next_num: 0,
            competition_id: 0,
        };

        this.addItem = this.addItem.bind(this);
        this.removeItem = this.removeItem.bind(this);
        this.handleCompetitionChange = this.handleCompetitionChange.bind(this);
    }

    componentWillMount() {
        let units = this.props.units;
        let items = (this.props.items !== null ? this.props.items : []);
        let key = 1;
        let num = 1;

        for (let item_key in items) {
            if (items.hasOwnProperty(item_key)) {
                items[item_key].key = key;
                items[item_key].num = (items[item_key].num || num);
                key++;
                num++;
            }
        }

        this.setState({
            units: units,
            items: items,
            next_key: items.length + 1,
            next_num: num,
        });
    }

    addItem() {
        let items = this.state.items;
        let key = this.state.next_key;
        let num = this.state.next_num;

        items.push({
            key: key,
            num: num,
            description: "",
            measurement_unit_id: 0,
            quantity: "",
            unit_price: "",
            total: "",
            vat: "",
            total_vat: ""
        });
        key++;
        num++;
        this.setState({
            items: items,
            next_key: key,
            next_num: num
        });
    }

    removeItem(key) {
        let items = this.state.items;
        items = items.filter((item) => item.key !== key);

        let num = 1;
        for (let idx in items) {
            if (items.hasOwnProperty(idx)) {
                items[idx].num = num;
                num++;
            }
        }

        this.setState({
            items: items,
            next_num: num,
        });
    }

    getCompetitions(input) {
        if (!input) {
            return Promise.resolve({options: []});
        }

        return axios("/contracts/ajax/competitions/search/" + input)
            .then((response) => {
                return {options: response.data};
            });
    }

    handleCompetitionChange(value, event) {
        let competition_id = 0;
        if (value !== null)
            competition_id = value.value;

        // Autofill supplier details
        this.setState({
            competition_id: competition_id
        }, () => {
            if (competition_id !== 0) {
                axios
                    .get("/contracts/ajax/competitions/" + competition_id + "/items")
                    .then((response) => {
                        let existing_items = this.state.items;
                        let new_items = response.data;
                        let next_key = this.state.next_key;

                        for (let idx in new_items) {
                            if (new_items.hasOwnProperty(idx)) {
                                let item = new_items[idx];
                                item.key = next_key;
                                item.quantity = item.quantity_comma;
                                existing_items.push(item);
                                next_key++;
                            }
                        }

                        let num = 1;
                        for (let idx in existing_items) {
                            if (existing_items.hasOwnProperty(idx)) {
                                existing_items[idx].num = num;
                                num++;
                            }
                        }

                        this.setState({
                            items: existing_items,
                            next_key: next_key,
                            next_num: num,
                        });
                    });
            }
        });
    }

    render() {
        let items = this.state.items;
        let rows = [];
        if (items.length > 0) {
            for (let item_index in items) {
                if (items.hasOwnProperty(item_index)) {
                    let row = items[item_index];
                    rows.push(
                        <ContractItem units={this.state.units}
                                      key={row.key}
                                      item={row}
                                      removeFn={this.removeItem}/>
                    );
                }
            }
        } else {
            rows.push(
                <tr key="0">
                    <td colSpan="9">
                        <em dangerouslySetInnerHTML={{__html: window.__js_contracts.no_items_add_msg}}></em>
                    </td>
                </tr>
            );
        }

        return (
            <div>
                <div className="row">
                    <div className="col-sm-offset-4 col-sm-8">
                        <legend>{window.__js_contracts.items_table}</legend>
                    </div>
                </div>

                <ConditionalBlock show={window._has_competitions_permission}>
                    <div className="form-group">
                        <label htmlFor="competition_id" className="control-label col-md-4">
                            {window.__js_contracts.add_items_from_competition}
                        </label>
                        <div className="col-md-8">
                            <Select.Async id="competition_id"
                                          value={this.state.competition_id}
                                          onChange={this.handleCompetitionChange}
                                          loadOptions={this.getCompetitions}/>
                            <span className="help-block">
                            {window.__js_contracts.find_competition_by}
                        </span>
                        </div>
                    </div>
                </ConditionalBlock>

                <div className="form-group">
                    <div className="col-md-12">
                        <Button onClick={this.addItem}
                                bsStyle="primary">
                            <i className="fa fa-plus"></i> {window.__js_contracts.add_item}
                        </Button>
                    </div>
                </div>

                <div className="form-group">
                    <div className="col-md-12">
                        <div id="contract-items-container">
                            <div id="contract-items-head" className="like-row like-thead">
                                <div className="num like-cell">Α/Α</div>
                                <div className="description like-cell">{window.__js_contracts.item_description}*</div>
                                <div className="measurement-unit like-cell">
                                    {window.__js_contracts.measurement_unit}*
                                </div>
                                <div className="quantity like-cell">{window.__js_contracts.quantity}*</div>
                                <div className="unit-price like-cell">{window.__js_contracts.unit_price}*</div>
                                <div className="total like-cell">{window.__js_contracts.total_without_vat}</div>
                                <div className="vat like-cell">{window.__js_contracts.vat_rate}</div>
                                <div className="total-vat like-cell">{window.__js_contracts.total_with_vat}</div>
                                <div className="remove like-cell"></div>
                            </div>
                            <div className="like-tbody">
                                {rows}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}